export default {
    init: (el) => {
        /* add specified class to element when threshold amount in view */
        let visible = false;
        const threshold = Number(el.dataset.threshold) || 0.2;
        const activeClass = el.dataset.activeClass || "active";

        const observer = new IntersectionObserver(
            (entries) => {
                if (!visible && entries[0].isIntersecting) {
                    visible = true;
                    el.classList.add(activeClass);
                    if (el.dataset.removeClass) {
                        el.classList.remove(el.dataset.removeClass);
                    }
                }
            },
            { threshold: threshold }
        );

        observer.observe(el);
    },
};
